import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { QueryResponse } from 'api/queries/productivityRate.query';

import { InformationBoxes } from 'components/common/informationBoxes/informationBoxes';

import localClasses from 'components/widgets/RunRateChart/components/boxes.module.scss';
import { UseProductivityRateProvider } from 'components/widgets/RunRateChart/productivityRate.provider';

interface Props {
    ui: UseProductivityRateProvider['ui'];
    data: QueryResponse | undefined;
}
export const Boxes = ({ data, ui }: Props) => {
    const aggregationValue = ui.state.aggregation;

    return (
        <InformationBoxes className={localClasses.row}>
            <InformationBoxes.Box>
                <div className={localClasses.box}>
                    <div className={localClasses.title}>Past Planned ({aggregationValue})</div>
                    <div data-testid={'planed-box-info'} className={`${localClasses.info} ${localClasses.planed}`}>
                        {data?.pastPlanned?.activities} Activities / {data?.pastPlanned?.rangeLabel}
                    </div>
                    <div>(As of {moment(data?.pastPlanned?.date).format(constants.formats.date.default)})</div>
                </div>
            </InformationBoxes.Box>
            <InformationBoxes.Box>
                <div className={localClasses.box}>
                    <div className={localClasses.title}>Past Actual ({aggregationValue})</div>
                    <div data-testid={'actual-box-info'} className={`${localClasses.info} ${localClasses.actual}`}>
                        {data?.pastActual?.activities} Activities / {data?.pastPlanned?.rangeLabel}
                    </div>
                    <div>(As of {moment(data?.pastActual?.date).format(constants.formats.date.default)})</div>
                </div>
            </InformationBoxes.Box>
            <InformationBoxes.Box>
                <div className={localClasses.box}>
                    <div className={localClasses.title}>Future Planned ({aggregationValue})</div>
                    <div data-testid={'future-box-info'} className={`${localClasses.info} ${localClasses.future}`}>
                        {data?.futurePlanned?.activities} Activities / {data?.pastPlanned?.rangeLabel}
                    </div>
                    <div>(As of {moment(data?.futurePlanned?.date).format(constants.formats.date.default)})</div>
                </div>
            </InformationBoxes.Box>
        </InformationBoxes>
    );
};
